import { useTheme } from "@emotion/react";
import { IconButton, Tooltip, Typography } from "@mui/material"
import { UseFieldArrayReturn, UseFormReturn, Path} from "react-hook-form";
import { DocumentWorkAdd } from "../../../../models/document-work";
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import { DocumentStructure } from "../../../../models/document-structure";
import MuiInput from "@shared/ui/mui-input/MuiInput";
import { useLocation, useNavigate } from "react-router-dom";
import { DocumentSettings } from "../../../../models/document-settings";
import { useEffect, useRef, useState } from "react";
import { DocumentAdd, DocumentEdit } from "../../../../models/document";
import { ItemsFormType, PaymentsFormType, WorksFormType } from "../../pages/add-document/AddDocument.types";
import { fixedNumber } from "@shared/lib/utils";
import { Work } from "../../../../models/work";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ClearIcon from '@mui/icons-material/Clear';

interface documentWorksProps {

    method: "add" | "edit";

    // worksForm: UseFormReturn<{ works: DocumentWorkAdd[] }> | UseFormReturn<{ works: DocumentWorkEdit[] }>;
    documentForm: UseFormReturn<DocumentAdd> | UseFormReturn<DocumentEdit>;
    worksForm: UseFormReturn<WorksFormType>
    itemsForm: UseFormReturn<ItemsFormType>
    paymentsForm: UseFormReturn<PaymentsFormType>

    worksFieldArray: UseFieldArrayReturn<{ works: DocumentWorkAdd[] }, "works", "id">;

    settings: DocumentSettings;
    structure: DocumentStructure[];

    calcDocument: () => void;
    isDocumentClosed?: boolean;
}


function DocumentWorks({ method, documentForm, worksForm, itemsForm, paymentsForm, worksFieldArray, settings, structure, calcDocument, isDocumentClosed }: documentWorksProps) {

    const navigate = useNavigate();
    const { state, pathname } = useLocation();
    const theme = useTheme();

    const [workRowIndex, setWorkRowIndex] = useState<number>(0); // work row index clicked
    const userTriggered = useRef<boolean>(true);



    //update work line when one field in the line changes.
    useEffect(() => {

        const subscription = worksForm.watch((_, { name }) => {

            if (userTriggered.current === true && name?.includes("works.")) {
                updateWorkRow(name);
            }
        });

        return () => subscription.unsubscribe();

    }, [worksForm]);


    function renderWorkField(field: DocumentStructure, rowIndex: number) {

        const calcFields = ["hours", "price", "discount", "net", "total"];

        if(calcFields.includes(field.field_name)){
            return <MuiInput 
                key={field.field_name}
                field={field}
                variant='outlined'
                useForm={worksForm}
                prefix={`works.${rowIndex}.`}
                showRequired
                disabled={isDocumentClosed}
            />
        }
        
        else{
            return <MuiInput 
                key={field.field_name}
                field={field}
                variant='outlined'
                useForm={worksForm}
                prefix={`works.${rowIndex}.`}
                showRequired
                disabled={isDocumentClosed}
                searchType="עבודה"
                onSelect={onWorkSelect}
            />
        }
    }
    
    
    function onWorkSelect(work: Work){

        const updatedWorks: DocumentWorkAdd[] = [...worksForm.getValues().works];

        updatedWorks[workRowIndex] = {
            ...work,
            id: undefined,
            work_id: work.id,
            hours: 1,
            price: work.price ?? 0,
            net: work.price ?? 0,
            total: work.price ?? 0
        };

        worksForm.reset({
            works: updatedWorks
        });
    }
    


    // update work row after one field changed
    function updateWorkRow(name: Path<WorksFormType>) {

        userTriggered.current = false;

        const firstDotIndex = name.indexOf('.');
        const secondDotIndex = name.indexOf('.', firstDotIndex + 1);

        const rowIndex = Number(name.substring(firstDotIndex + 1, secondDotIndex));
        const fieldName = name?.slice(secondDotIndex + 1);

        const hours = worksForm.getValues(`works.${rowIndex}.hours`) || 1;
        const price = worksForm.getValues(`works.${rowIndex}.price`);
        const discount = worksForm.getValues(`works.${rowIndex}.discount`);
        const net = worksForm.getValues(`works.${rowIndex}.net`);
        const total = worksForm.getValues(`works.${rowIndex}.total`);

        let updatedNet;
        let updatedPrice;

        switch (fieldName) {

            case 'price': case 'discount':

                updatedNet = price * (1 - ((discount || 0) / 100));

                worksForm.setValue(`works.${rowIndex}.hours`, hours);
                worksForm.setValue(`works.${rowIndex}.net`, fixedNumber(updatedNet));
                worksForm.setValue(`works.${rowIndex}.total`, fixedNumber(updatedNet * (hours || 1)));

                break;

            case 'hours':

                worksForm.setValue(`works.${rowIndex}.price`, fixedNumber((net || 0) / (1 - ((discount || 0) / 100))));
                worksForm.setValue(`works.${rowIndex}.total`, fixedNumber((net || 0) * (hours || 1)));

                break;

                
            case 'net':


                worksForm.setValue(`works.${rowIndex}.discount`, fixedNumber((1 - ((net || 0) / price)) * 100));
                worksForm.setValue(`works.${rowIndex}.total`, fixedNumber((net || 0) * hours));

                break;


            case 'total':

                updatedPrice = (total || 0) / ((hours || 1) * ((1 - ((discount || 0) / 100)) || 1));

                worksForm.setValue(`works.${rowIndex}.price`, fixedNumber(updatedPrice));
                worksForm.setValue(`works.${rowIndex}.net`, fixedNumber(updatedPrice * (1 - ((discount || 0) / 100))));

                break;

            default:
                break;
        }

        userTriggered.current = true;

        //calc the new payment section
        calcDocument();
    }


    //add a new work line
    function addWorkLine() {

        worksFieldArray.append({
            name: "",
            hours: 1,
            price: 0,
            discount: 0,
            net: 0,
            total: 0,
        });

        setWorkRowIndex(worksFieldArray.fields.length);

    }



    //deleting a row by specify an index
    function deleteRow(index: number): void {

        setWorkRowIndex(0);
        worksFieldArray.remove(index);
        calcDocument();
    }



    function createState(){
            return {
                ...state,
                from: pathname,
                document_settings_id: settings?.id,
    
                document_account: documentForm.getValues().document_account,
                car: documentForm.getValues().car,
    
                works: worksForm.getValues().works,
                items: itemsForm.getValues().items,
                payments: paymentsForm.getValues().payments,
                reference: documentForm.getValues().reference,
    
                workRowIndex: workRowIndex,
    
            }
        }
    
        
    function createBreadcrumbData(state: any){

        const thisPageLink = 'id' in documentForm.getValues() ?
            `/documents/${(documentForm as  UseFormReturn<DocumentEdit>).getValues("id")}` :
            `/documents/add?documentType=${settings?.id}`;

        return [
            {
                name: "מסמכים",
                link: "/documents",
            },
            {
                name: "הוספת מסמך",
            },
            {
                name: `${settings?.name}`,
                link: thisPageLink,
                state: state
            },
        ];
    }



    //navigate to work browsing
    function browseWork() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState);

        navigate(`/works`, {
            replace: true,
            state: {
                ...currentState,
                breadcrumbData: [...breadcrumbData, { name: "בחירת עבודה" }]
            }
        });
    }


    //navigate to add work
    function addWork() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState);

        navigate(`/works/add`, {
            replace: true,
            state: {
                ...currentState,
                breadcrumbData: [...breadcrumbData, { name: "הוספת כרטיס עבודה" }]
            }
        });
    }


    //navigate to edit work
    function editWork() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState);

        navigate(`/works/${worksForm.getValues().works[workRowIndex]?.work_id || worksForm.getValues().works[workRowIndex]?.id}`, {
            replace: true,
            state: {
                ...currentState,
                breadcrumbData: [...breadcrumbData, { name: "עריכת כרטיס עבודה" }]
            }
        });
    }
    

    function editWorkStructure() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState);

        navigate(`/documents/structure/work?documentType=${settings.id}`, {
            replace: true, 
            state: {
                breadcrumbData: [...breadcrumbData, { name: "הגדרת מבנה" },{ name: "עבודה" }]
            }
        });
    }



    if (method === "add") {
        return (
            
            
            <>
                <div className="title">
                    <div>
                        <Typography variant="body1" component="span">
                            עבודות:
                        </Typography>
                        <Tooltip title="בחירת כרטיס עבודה מתוך דפדוף" placement="top">
                            <IconButton onClick={browseWork} sx={{ color: theme.colors.main_color }}>
                                <AutoStoriesIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="הוספת כרטיס עבודה" placement="top">
                            <span>
                                <IconButton onClick={addWork} disabled={!!worksForm.getValues().works?.[workRowIndex]?.id} sx={{ color: theme.colors.main_color }}>
                                    <BookmarkAddIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="עריכת כרטיס עבודה" placement="top">
                            <span>
                                <IconButton onClick={editWork} disabled={!worksForm.getValues().works?.[workRowIndex]?.id} sx={{ color: theme.colors.main_color }}>
                                    <EditIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="הוספת שורה" placement="top">
                            <span>
                                <IconButton onClick={addWorkLine} sx={{ color: theme.colors.main_color }}>
                                    <ExpandMoreIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </div>
                    <div>
                        <Tooltip title="הגדרת שדות עבודה" placement="top">
                            <span>
                                <IconButton onClick={editWorkStructure} sx={{ color: theme.colors.main_color }}>
                                    <SettingsIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </div>
                </div>

                <table>
                    <tbody>
                        {
                            worksFieldArray.fields.map((field, rowIndex) => (

                                <tr key={field.id} onClick={() => { setWorkRowIndex(rowIndex) }}>
                                    <td className="row-number">{rowIndex + 1}.</td>
                                    {
                                        structure?.sort((a, b) => (a.location || 0) - (b.location || 0)).map(field => {
                                            return (field.type === "עבודה" && field.show_form) ? 
                                                <td key={field.field_name}>
                                                    {/* <MuiInput field={field} variant='outlined' useForm={worksForm} prefix={`works.${rowIndex}.`} showRequired autoFocus={isFocused(`works.${rowIndex}.`, field.field_name)} /> */}
                                                    {
                                                        renderWorkField(field, rowIndex)
                                                    }
                                                </td> : null
                                        })
                                    }
                                    <td className="delete-row">
                                        <Tooltip title="הסרת שורה" placement="top">
                                            <span>
                                                <IconButton onClick={()=>{deleteRow(rowIndex)}} sx={{ color: theme.colors.main_color }}>
                                                    <ClearIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </td>
                                </tr>

                            ))
                        }
                    </tbody>
                </table>
            </>
        )
    }

    else if (method === "edit") {
        return (
            <>
                <div className="title">
                    <div>
                        <Typography variant="body1" component="span" sx={{
                            color: !isDocumentClosed ? "text.primary" : "action.disabled",
                        }}>
                            עבודות:
                        </Typography>
                        <Tooltip title="בחירת כרטיס עבודה מתוך דפדוף" placement="top">
                            <span>
                                <IconButton onClick={browseWork} sx={{ color: theme.colors.main_color }} disabled={isDocumentClosed}>
                                    <AutoStoriesIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="הוספת כרטיס עבודה" placement="top">
                            <span>
                                <IconButton onClick={addWork} disabled={!!worksForm.getValues().works?.[workRowIndex]?.id || isDocumentClosed} sx={{ color: theme.colors.main_color }}>
                                    <BookmarkAddIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="עריכת כרטיס עבודה" placement="top">
                            <span>
                                <IconButton onClick={editWork} disabled={!worksForm.getValues().works?.[workRowIndex]?.id || isDocumentClosed} sx={{ color: theme.colors.main_color }}>
                                    <EditIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="הוספת שורה" placement="top">
                            <span>
                                <IconButton onClick={addWorkLine} disabled={isDocumentClosed} sx={{ color: theme.colors.main_color }}>
                                    <ExpandMoreIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </div>
                    <div>
                        <Tooltip title="הגדרת שדות עבודה" placement="top">
                            <span>
                                <IconButton onClick={editWorkStructure} sx={{ color: isDocumentClosed? "rgba(0,0,0,0.3)" : theme.colors.main_color }}>
                                    <SettingsIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </div>
                </div>

                <table className={isDocumentClosed? "disabled" : ""}>
                    <tbody>
                        {
                            worksFieldArray.fields.map((field, rowIndex) => (

                                <tr key={field.id} onClick={() => { setWorkRowIndex(rowIndex) }}>
                                    <td className="row-number">{rowIndex + 1}.</td>
                                    {
                                        structure?.sort((a, b) => (a.location || 0) - (b.location || 0)).map(field => {
                                            // return (field.type === "עבודה" && field.show_form) ? <td key={field.field_name}><MuiInput field={field} variant='outlined' useForm={worksForm} prefix={`works.${rowIndex}.`} showRequired autoFocus={isFocused(`works.${rowIndex}.`, field.field_name)} disabled={isDocumentClosed} /></td> : null
                                            return (field.type === "עבודה" && field.show_form) ? 
                                                <td key={field.field_name}>
                                                    {/* <MuiInput field={field} variant='outlined' useForm={worksForm} prefix={`works.${rowIndex}.`} showRequired autoFocus={isFocused(`works.${rowIndex}.`, field.field_name)} /> */}
                                                    {
                                                        renderWorkField(field, rowIndex)
                                                    }
                                                </td> : null
                                        })
                                    }
                                    <td className="delete-row">
                                        <Tooltip title="הסרת שורה" placement="top">
                                            <span>
                                                <IconButton onClick={()=>{deleteRow(rowIndex)}} sx={{ color: theme.colors.main_color }} disabled={isDocumentClosed}>
                                                    <ClearIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </td>
                                </tr>

                            ))
                        }
                    </tbody>
                </table>
            </>
        )
    }
}

export default DocumentWorks